import { Switch, Route, Redirect } from 'react-router-dom';
import Profile from 'pages/Profile';
import Login from 'pages/Login';
import SingleEventPage from "./components/event/SingleEventPage"
// Font Awesome Style Sheet
import '@fortawesome/fontawesome-free/css/all.min.css';

// Tailwind CSS Style Sheet
import 'assets/styles/tailwind.css';

function App() {
    return (
        <Switch>
            <Route exact path="/dashboard" component={Profile} />
            <Route exact path="/dashboard/event" component={SingleEventPage} />
            <Route exact path="/" component={Login} />
            <Redirect from="*" to="/" />
        </Switch>
    );
}

export default App;
